import classNames from 'classnames'

import styles from '../styles/StepExam.module.scss'

export default function ExamTitle({ title, fadeClass }) {
  return title ? <p className={classNames(styles.examTitle, styles[fadeClass])}>{title}</p> : null
}
